import React, { useState } from 'react';
import { 
  Sparkles, Calendar, Shirt, Send, 
  PartyPopper, Plus, Trash2, 
  Users, ChevronRight, X
} from 'lucide-react';

// ✅ CONEXIÓN AL SISTEMA NERVIOSO CENTRAL (Ruta Absoluta)
import { useGlobal } from 'context/GlobalContext';

const ProgramadorEventos = () => {
  // Consumimos la función para publicar eventos globalmente en la Nube
  const { setEventosGlobal } = useGlobal();

  const [paso, setPaso] = useState(1); 
  
  const [evento, setEvento] = useState({
    titulo: '',
    fecha: '',
    vestimenta: 'Libre',
    gruposDestino: ['Todos'] 
  });

  const [mochila, setMochila] = useState([
    { id: 1, item: 'Mini croissants', asignadoA: 'Párvulos A' },
    { id: 2, item: 'Muffins de chocolate', asignadoA: 'Cuna' },
  ]);
  
  const [nuevoItem, setNuevoItem] = useState({ item: '', asignadoA: 'Todos' });

  const gruposDisponibles = ['Todos', 'Cuna', 'Párvulos A', 'Párvulos B', 'Primaria Menor', 'Primaria Mayor'];

  const sugerenciasTemporada = [
    { titulo: 'Festival de Primavera 🌻', vestimenta: 'Ropa floral / Colores vivos' },
    { titulo: 'Día de Superhéroes ⚡', vestimenta: 'Playera de superhéroe' },
    { titulo: 'Domingo de Pijamas 🧸', vestimenta: 'Pijama completa cómoda' }
  ];

  const aplicarSugerencia = (sug) => {
    setEvento({ ...evento, titulo: sug.titulo, vestimenta: sug.vestimenta });
  };

  const toggleGrupoDestino = (grupo) => {
    setEvento(prev => {
      if (grupo === 'Todos') return { ...prev, gruposDestino: ['Todos'] };
      const nuevos = prev.gruposDestino.includes(grupo) 
        ? prev.gruposDestino.filter(g => g !== grupo) 
        : [...prev.gruposDestino.filter(g => g !== 'Todos'), grupo];
      return { ...prev, gruposDestino: nuevos.length === 0 ? ['Todos'] : nuevos };
    });
  };

  const agregarAMochila = () => {
    if(!nuevoItem.item) return;
    setMochila([...mochila, { id: Date.now(), ...nuevoItem }]);
    setNuevoItem({ item: '', asignadoA: 'Todos' });
  };

  const eliminarDeMochila = (id) => {
    setMochila(mochila.filter(m => m.id !== id));
  };

  const publicarEventoFinal = () => {
    if(!evento.titulo) return alert("El evento requiere un título oficial.");
    
    const eventoCompleto = {
      ...evento,
      id: Date.now(),
      materiales: mochila,
      timestamp: new Date().toISOString(),
      urgente: true // Por defecto para resaltar en la App del padre
    };

    // Publicamos en el estado global para sincronización total
    setEventosGlobal(prev => [eventoCompleto, ...prev]);
    
    alert("🚀 ¡CONVOCATORIA LANZADA!\nLos padres recibirán el aviso en su sección de eventos.");
    
    // Resetear flujo
    setEvento({ titulo: '', fecha: '', vestimenta: 'Libre', gruposDestino: ['Todos'] });
    setMochila([]);
    setPaso(1);
  };

  return (
    <div className="w-full max-w-[1400px] mx-auto space-y-8 animate-in fade-in duration-500 pb-20 px-4 font-sans text-left">
      
      {/* HEADER DE CREACIÓN */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 border-b-4 border-slate-100 pb-8">
        <div className="space-y-2 text-left">
          <div className="inline-flex items-center gap-2 bg-fuchsia-50 text-fuchsia-600 px-6 py-2 rounded-full mb-2 border border-fuchsia-100 shadow-sm">
            <PartyPopper size={18} className="animate-bounce" />
            <span className="text-[10px] font-black uppercase tracking-[0.2em] italic">Gestión de Experiencias IgleKids</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 italic tracking-tighter uppercase leading-none">Eventos</h2>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        
        {/* CONFIGURADOR IZQUIERDO */}
        <div className="lg:col-span-7 space-y-6">
          <div className="bg-white rounded-[4rem] shadow-2xl border-4 border-slate-50 overflow-hidden">
            <div className="flex bg-slate-50 border-b-2 border-slate-100">
              <button onClick={() => setPaso(1)} className={`flex-1 py-8 text-[11px] font-black uppercase tracking-widest transition-all ${paso === 1 ? 'bg-white text-fuchsia-600 border-b-4 border-fuchsia-500 shadow-sm' : 'text-slate-400 opacity-50'}`}>
                1. Concepto
              </button>
              <button onClick={() => setPaso(2)} className={`flex-1 py-8 text-[11px] font-black uppercase tracking-widest transition-all ${paso === 2 ? 'bg-white text-indigo-600 border-b-4 border-indigo-500 shadow-sm' : 'text-slate-400 opacity-50'}`}>
                2. Materiales
              </button>
            </div>

            <div className="p-10 md:p-14 text-left">
              {paso === 1 ? (
                <div className="space-y-10 animate-in slide-in-from-left-8">
                  {/* Sugerencias Inteligentes */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {sugerenciasTemporada.map((sug, idx) => (
                      <button key={idx} onClick={() => aplicarSugerencia(sug)} className="p-6 bg-[#0A2440] text-white rounded-[2rem] text-left border-b-8 border-slate-800 hover:bg-fuchsia-600 hover:border-fuchsia-800 transition-all flex items-center justify-between group shadow-lg">
                        <span className="font-black text-[11px] uppercase tracking-wider italic">{sug.titulo}</span>
                        <ChevronRight size={18} className="opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                      </button>
                    ))}
                  </div>

                  <div className="space-y-8">
                    <div className="space-y-3">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-6 italic">Título del Evento</label>
                      <input type="text" value={evento.titulo} onChange={(e) => setEvento({...evento, titulo: e.target.value.toUpperCase()})} className="w-full p-8 bg-slate-50 rounded-[2.5rem] border-2 border-transparent focus:border-fuchsia-500 text-2xl font-black italic text-slate-800 outline-none shadow-inner transition-all uppercase" placeholder="EJ. DÍA DEL NIÑO..." />
                    </div>

                    <div className="space-y-4">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-6 italic">Grupos Invitados</label>
                      <div className="flex flex-wrap gap-3 p-6 bg-slate-50 rounded-[3rem] border-2 border-slate-100 shadow-inner">
                        {gruposDisponibles.map(grupo => (
                          <button key={grupo} onClick={() => toggleGrupoDestino(grupo)} className={`px-6 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all border-2 ${evento.gruposDestino.includes(grupo) ? 'bg-indigo-600 border-indigo-700 text-white shadow-xl scale-105' : 'bg-white border-slate-100 text-slate-400'}`}>
                            {grupo}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-10 animate-in slide-in-from-right-8">
                  <div className="bg-indigo-50 p-8 rounded-[3.5rem] border-2 border-indigo-100 space-y-6 shadow-inner">
                    <h4 className="text-[10px] font-black text-indigo-500 uppercase tracking-[0.2em] flex items-center gap-2 italic ml-4">
                      <Plus size={16}/> Requerimientos para los padres
                    </h4>
                    <div className="flex flex-col md:flex-row gap-4">
                      <input type="text" value={nuevoItem.item} onChange={(e) => setNuevoItem({...nuevoItem, item: e.target.value})} placeholder="Ej. Traer lunch extra o fomi..." className="flex-[2] p-5 bg-white rounded-2xl border-none font-bold text-slate-700 shadow-sm outline-none" />
                      <select value={nuevoItem.asignadoA} onChange={(e) => setNuevoItem({...nuevoItem, asignadoA: e.target.value})} className="flex-1 p-5 bg-white rounded-2xl border-none font-black text-[10px] uppercase tracking-widest outline-none shadow-sm cursor-pointer appearance-none">
                        {gruposDisponibles.map(g => <option key={g} value={g}>{g}</option>)}
                      </select>
                      <button onClick={agregarAMochila} className="p-5 bg-[#0A2440] text-white rounded-2xl hover:bg-emerald-500 transition-all shadow-xl active:scale-95">
                        <Plus size={28} />
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[400px] overflow-y-auto pr-4 hide-scrollbar">
                    {mochila.map(m => (
                      <div key={m.id} className="p-6 bg-white rounded-[2.5rem] border-2 border-slate-100 shadow-sm flex items-center justify-between group hover:border-indigo-200 transition-all">
                        <div className="text-left">
                          <p className="text-sm font-black text-slate-800 uppercase tracking-tight italic">{m.item}</p>
                          <span className="text-[9px] font-black text-indigo-500 uppercase tracking-widest italic bg-indigo-50 px-3 py-1 rounded-full mt-2 inline-block">Para: {m.asignadoA}</span>
                        </div>
                        <button onClick={() => eliminarDeMochila(m.id)} className="p-3 bg-rose-50 text-rose-300 hover:text-rose-600 hover:bg-rose-100 rounded-xl transition-all"><Trash2 size={18}/></button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* VISTA PREVIA DERECHA */}
        <div className="lg:col-span-5 space-y-6">
          <div className="bg-[#0A2440] rounded-[4rem] p-12 text-white shadow-2xl relative overflow-hidden border-b-8 border-fuchsia-600">
            <div className="absolute -right-20 -top-20 w-80 h-80 bg-fuchsia-500/10 rounded-full blur-3xl" />
            <div className="relative z-10 space-y-10 text-left">
              <div>
                <span className="text-[10px] font-black uppercase tracking-[0.5em] text-amber-500 italic">Previsualización en App</span>
                <h3 className="text-5xl font-black italic tracking-tighter leading-none mt-8 uppercase">
                  {evento.titulo || "Título del Evento"}
                </h3>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-5 bg-white/5 p-6 rounded-[2.5rem] border border-white/10 shadow-inner">
                   <div className="w-14 h-14 bg-fuchsia-500/20 rounded-2xl flex items-center justify-center text-fuchsia-400">
                      <Users size={32} />
                   </div>
                   <div>
                     <p className="text-[9px] font-black uppercase tracking-widest text-slate-500 mb-1 italic">Público:</p>
                     <p className="text-sm font-black italic">{evento.gruposDestino.join(', ')}</p>
                   </div>
                </div>
                <div className="flex items-center gap-5 bg-white/5 p-6 rounded-[2.5rem] border border-white/10 shadow-inner">
                   <div className="w-14 h-14 bg-amber-500/20 rounded-2xl flex items-center justify-center text-amber-400">
                      <Shirt size={32} />
                   </div>
                   <div>
                     <p className="text-[9px] font-black uppercase tracking-widest text-slate-500 mb-1 italic">Código de Vestimenta:</p>
                     <p className="text-sm font-black italic">{evento.vestimenta}</p>
                   </div>
                </div>
              </div>

              <div className="pt-8">
                <button 
                  onClick={publicarEventoFinal}
                  className="w-full py-8 bg-fuchsia-600 text-white rounded-[3.5rem] font-black text-sm uppercase tracking-[0.3em] shadow-2xl hover:bg-fuchsia-500 transition-all flex items-center justify-center gap-4 active:scale-95 border-b-8 border-fuchsia-800"
                >
                  <Send size={24} className="text-white" /> LANZAR CONVOCATORIA
                </button>
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center mt-6 italic">Al lanzar, se notificará a todos los padres involucrados.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProgramadorEventos;